import { AsnState } from '../../interfaces/Asn/AsnState'
import {
  GET_ASN_STATE_EXITO,
  GET_ASN_STATE
} from '../types/asnStateActionsTypes'

export type AsnStateAction = AsnStatesAction | AsnStatesActionAsync

// Esto va a REDUX
export interface AsnStatesAction {
  type: typeof GET_ASN_STATE_EXITO
  asnState: AsnState[] | undefined
  error: string | undefined
}

export const getAsnStateAction = (
  asnState?: AsnState[],
  error?: string
): AsnStatesAction => {
  return {
    type: GET_ASN_STATE_EXITO,
    asnState: asnState,
    error
  }
}

// Esto va a SAGA
export interface AsnStatesActionAsync {
  type: typeof GET_ASN_STATE
}

export const getAsnStateActionAsync = (): AsnStatesActionAsync => {
  return {
    type: GET_ASN_STATE
  }
}
